import { useQuery } from "@tanstack/react-query";
import httpRequest from "app/lib/axios/index";

interface VehicleBrand {
  id: string;
  name: string;
}

const fetchVehicleBrandById = async (makeId: string): Promise<VehicleBrand> => {
  const response = await httpRequest.get<VehicleBrand>(
    `vehicle/models?makeId=${makeId}`
  );
  return response.data;
};

export const useFetchVehicleBrandById = (makeId: string) => {
  return useQuery<VehicleBrand>({
    queryKey: ["vehicleBrand", makeId],
    queryFn: () => fetchVehicleBrandById(makeId),
    enabled: !!makeId,
  });
};
